/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js';
import router from '@/router';

export default {
  loginJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(payload.userDetails.username, payload.userDetails.password)
        .then(response => {
          // If there's token data in response
          console.log('ActionResolver', response);
          if (response.data.jwt) {
            // Set bearer token in axios
            commit('SET_TOKEN', response.data);

            resolve(response.data);
          } else {
            reject({ message: 'Wrong Email or Password' });
          }
        })
        .then(response => {
          // Update user details
          if (response.data.data) {
            commit('UPDATE_USER_INFO', response.data.data);

            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/');

            resolve(response);
          } else {
            reject({ message: 'Invalid token' });
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  attempt({ commit }, token) {
    return jwt.me(token);
  },

  fetchAccessToken({ commit }) {
    return new Promise((resolve, reject) => {
      jwt
        .refreshToken()
        .then(response => {
          commit('SET_TOKEN', response.data.original);
          resolve(response.data.original.accessToken);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  refreshUserInfo({ state, commit }) {},
  logout({ commit }) {
    commit('LOGOUT_USER');
    router.push('/pages/login');
  }
};
